<template>
  <div class="specialAttention">
    <div class="head">
      <div class="bodyTitle">
        <img alt src="../assets/Starting/img-hot/newstitle0.png" />
        <div class="pageTitle">{{ pageTitle }}</div>
        <img
          alt
          class="img_monitor"
          src="../assets/Starting/img-hot/newstitle0.png"
        />
      </div>
    </div>
    <div class="main">
      <div class="cilre">
        <div @click="pauseOrPlay()" class="eventBtn" v-show="true">
          <div class="stop" id="eventBtn"></div>
        </div>
      </div>
      <ul class="news" id="news">
        <li
          :data-topic_id="index"
          :key="index"
          @click="showDialog(item)"
          class="newslist animated fadeInDown"
          v-for="(item, index) in active_data"
        >
          <div class="news-box">
            <div class="r info">
              {{ item.NEWS_TIME.slice(0, 10) | temp_filter }}
            </div>
            <div class="r info">
              {{ item.SOURCE_NAME | temp_filter }}
            </div>
            <h5 @click="goind(item, item.text, item.CONTENT)">
              {{ item.title | temp_filter }}
            </h5>
            <p class="textp">{{ item.CONTENT | temp_filter }}</p>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="body_tiele">
        {{ this.list.title }}
        <img
          class="body_img"
          @click="goindr(list.NET_URL)"
          src="@/assets/lian.png"
          alt=""
        />
      </div>
      <div class="live">
        {{ this.list.SOURCE_NAME }}
        <div>{{ this.list.NEWS_TIME }}</div>
      </div>
      <div class="body_cont">{{ this.list.CONTENT }}</div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js";
import { word } from "../api/re.js";
export default {
  data() {
    return {
      pageTitle: "热点新闻",
      active_data: [],
      imageFiles: "",
      hover: null,
      update_data: null,
      showBody: "",
      show: false,
      list: {},
      dialogVisible: false,
      index: 4,
    };
  },
  filters: {
    temp_filter(value) {
      if (value) {
        return value;
      } else {
        return "";
      }
    },
  },
  created() {
    if (this.$route.query.innerTitle) {
      this.pageTitle = this.$route.query.innerTitle;
    }
    //接口
    this.lond();
  },
  mounted() {
    this.pageInit();

    // 进页面刷新一下
    if (location.href.indexOf("#reloaded") == -1) {
      location.href = location.href + "#reloaded";
      location.reload();
    }
  },

  beforeDestroy() {
    this.stopScroll(true);
  },

  methods: {
    pageInit() {
      // this.getNews(); // 首次加载数据
      this.update_data = setInterval(() => {
        // this.getNews();
      }, 1000 * 60 * 10); // 数据刷新周期十分钟
    },
    goind(item, text, CONTENT) {
      this.dialogVisible = true;
      this.list = item;
    },
    goindr(url) {
      window.open(url);
    },
    handleClose(done) {
      this.dialogVisible = false;
    },
    showDialog(v) {
      this.showBody = v;
      this.show = true;
      // this.stopScroll();
    },
    closeDialog() {
      if (!this.show) {
        return;
      }
      this.show = false;
      var eventBtn = document.getElementById("eventBtn");
      if (eventBtn.className == "stop") {
        this.startScroll();
      }
      setTimeout(() => {
        this.showBody = "";
      }, 1200);
    },
    startScroll() {
      this.stopScroll();
      this.hover = setInterval(() => {
        // 最后一个元素前置
        let a = document.getElementsByClassName("newslist");
        let el = a[a.length - 1];
        // el.remove()
        document.getElementById("news").prepend(el);
        // 保存高亮项信息到localStorage
        if (this.index == 4) {
          this.index = 3;
        } else if (this.index == 3) {
          this.index = 2;
        } else if (this.index == 2) {
          this.index = 1;
        } else if (this.index == 1) {
          this.index = 0;
        } else if (this.index == 0) {
          this.index = 8;
        } else if (this.index == 8) {
          this.index = 7;
        } else if (this.index == 7) {
          this.index = 6;
        } else if (this.index == 6) {
          this.index = 5;
        } else if (this.index == 5) {
          this.index = 4;
        } else if (this.index == 4) {
          this.index = 3;
        }
        let active_el = a[0];
        let active_item = this.active_data.filter(
          (k) => k.index == active_el.dataset.index
        )[this.index];
        this.setStorage(active_item);
      }, 10000);
    },
    stopScroll() {
      clearInterval(this.hover);
      clearInterval(this.update_data);
      // clearDataUpdate && clearInterval(this.update_data);
    },
    setStorage(item) {
      console.log("触发新闻了");

      window.localStorage.setItem("topic_name", item.text);
      window.localStorage.setItem("topic_info", item.CONTENT);
    },
    //获取数据
    lond() {
      word({
        classification: "全部",
        dataSource: "全部",
        timeType: 1,
      }).then((res) => {
        let news = res.data.data;
        while (news.length < 9) {
          news = news.concat(news);
        }
        this.active_data = [];
        if (this.hover) {
          this.stopScroll();
        }
        // 依次放入&展示
        for (let i = 0; i < 9; i++) {
          setTimeout(() => {
            this.active_data.push(news[i]);
          }, i * 500);
        }
        // 延时展示后开始滚动
        setTimeout(() => {
          this.startScroll();
        }, news.length * 500);
      });
    },
    //暂停播放键
    pauseOrPlay() {
      var eventBtn = document.getElementById("eventBtn");
      if (eventBtn.className == "stop") {
        eventBtn.removeAttribute("stop");
        eventBtn.setAttribute("class", "play");
        this.stopScroll();
      } else {
        eventBtn.removeAttribute("play");
        eventBtn.setAttribute("class", "stop");
        this.startScroll();
      }
    },
    //改变日期格式
    getDate() {
      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      var day =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      var dateStr = year + "" + month + "" + day;
      return dateStr;
    },
  },
};
</script>

<style scoped lang="scss">
.body_tiele {
  font-size: 30px;
  font-family: PingFang;
  font-weight: bold;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
}
.body_img {
  position: relative;
  left: 5px;
  cursor: pointer;
}
.live {
  width: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  margin: 0 auto;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #60d6dd;
}
.body_cont {
  width: 90%;
  height: 60vh;
  overflow-y: scroll;
  margin: 0 auto;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 28px;
  color: #ffffff;
}
.specialAttention {
  background-image: url("../assets/Starting/img-hot/bodybg2_2.jpg");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: relative;
  .head {
    margin: 0 3vw;
    display: flex;
    align-items: center;
    height: 12vh;
    justify-content: space-between;
    user-select: none;
    position: relative;
    .bodyTitle {
      height: 7.4vh;
      font-size: 1.4vw;
      font-weight: bold;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        width: 6vw;
      }
      .img_monitor {
        transform: rotate(180deg);
      }
      .pageTitle {
        margin: 0 0.5em;
        white-space: nowrap;
      }
    }
  }
  .main {
    width: 100%;
    height: calc(100% - 12vh);
    position: relative;
    .cilre {
      position: absolute;
      width: 28vw;
      height: 83vh;
      border-radius: 50%;
      border: 1px solid #04def7;
      left: -18.7%;
      .eventBtn {
        position: absolute;
        top: calc(50% - 40px);
        right: 8%;
        padding: 20px;
        border-radius: 50%;
        background-color: rgba(23, 29, 66, 0.6);
        cursor: pointer;
        div.stop {
          background-image: url("../assets/Starting/img-hot/stop.png");
        }
        div.play {
          background-image: url("../assets/Starting/img-hot/play.png");
        }
        div {
          width: 40px;
          height: 40px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
    }
    .cilre:before {
      content: "";
      position: absolute;
      width: 50%;
      height: 57vh;
      border-radius: 50%;
      border: 1px solid #04def7;
      left: 30.5%;
      top: 50%;
      margin-top: -29vh;
      opacity: 0.5;
    }
    //右边
    .newslist {
      position: absolute;
      top: -500px;
      left: 0;
      opacity: 0;
      cursor: pointer;
      height: 5vh;
      line-height: 4.6vh;
      color: #fff;
      padding: 1.8vh 1.5% 1.8vh 3%;
      width: 86%;
      transition: all 0.6s;
      img {
        width: 0;
      }
      .info {
        color: #00ccff;
        text-align: right;
        white-space: nowrap;
        font-style: normal;
        font-size: 1.2vw;
        margin-right: 9%;
      }
      .news-box {
        &:after {
          content: "";
          clear: both;
          display: block;
          height: 0;
          overflow: hidden;
        }
      }
      &:before {
        content: "";
        display: block;
        position: absolute;
        left: -0.2%;
        top: 50%;
        width: 2%;
        height: 4vh;
        background: url("../assets/Starting/img-hot/dian.png") no-repeat center
          center;
        background-size: contain;
        border-radius: 50%;
        transform: translate(0, -50%);
      }
    }
    .newslist:nth-child(1) {
      position: absolute;
      top: 0.6vh;
      left: 5.6%;
      opacity: 0.2;
      transform: translate(-6.5%, 0);
      font-size: 1.2vw;
      .news-box {
        opacity: 0.4;
      }
    }
    .newslist:nth-child(2) {
      position: absolute;
      top: 7vh;
      left: 9.2%;
      opacity: 0.6;
      transform: translate(-6.5%, 0);
      font-size: 1.4vw;
      .news-box {
        opacity: 0.6;
      }
    }
    .newslist:nth-child(3) {
      position: absolute;
      top: 14.2vh;
      left: 11.4%;
      opacity: 0.8;
      transform: translate(-6.5%, 0);
      font-size: 1.6vw;
      .news-box {
        opacity: 0.8;
      }
    }
    .newslist:nth-child(4) {
      position: absolute;
      top: 23.1vh;
      left: 13.1%;
      opacity: 0.9;
      transform: translate(-6.5%, 0);
      font-size: 1.8vw;
      .news-box {
        opacity: 0.9;
      }
    }
    .newslist:nth-child(5) {
      position: absolute;
      top: 30vh;
      left: 14.2%;
      opacity: 1;
      transform: translate(-6.5%, 0);
      font-size: 2vw;
      color: #f5c512;
      height: 22.6vh;
      .news-box {
        opacity: 1;
        padding: 0.8vh 1.3% 1.5vh;
        background: url("../assets/Starting/img-hot/libg.png") no-repeat;
        background-size: 100% 100%;
        height: calc(100% - 4vh);
        overflow: hidden;
      }
      .textp {
        display: block;
        width: 80vw;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .info {
        margin-right: 8%;
      }
    }
    .newslist:nth-child(5):before {
      background: url("../assets/Starting/img-hot/dian1.png") no-repeat center
        center;
      background-size: contain;
    }
    .newslist:nth-child(6) {
      position: absolute;
      top: 51.9vh;
      left: 13.6%;
      opacity: 0.9;
      transform: translate(-6.5%, 0);
      font-size: 1.8vw;
      .news-box {
        opacity: 0.9;
      }
    }
    .newslist:nth-child(7) {
      position: absolute;
      top: 60.3vh;
      left: 12.2%;
      opacity: 0.8;
      transform: translate(-6.5%, 0);
      font-size: 1.6vw;
      .news-box {
        opacity: 0.8;
      }
    }
    .newslist:nth-child(8) {
      position: absolute;
      top: 67.8vh;
      left: 10.2%;
      opacity: 0.6;
      transform: translate(-6.5%, 0);
      font-size: 1.4vw;
      .news-box {
        opacity: 0.6;
      }
    }
    .newslist:nth-child(9) {
      position: absolute;
      top: 74.1vh;
      left: 7.8%;
      opacity: 0.4;
      transform: translate(-6.5%, 0);
      font-size: 1.2vw;
      .news-box {
        opacity: 0.4;
      }
    }
    .newslist:nth-child(1):before,
    .newslist:nth-child(9):before {
      background-size: 70% 70%;
    }
    .newslist:nth-child(2):before,
    .newslist:nth-child(8):before {
      background-size: 80% 80%;
    }
    .newslist:nth-child(3):before,
    .newslist:nth-child(7):before {
      background-size: 90% 90%;
    }
    .r {
      float: right;
      margin-right: 4%;
    }
    h5 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .textp {
      display: none;
      width: 80vw;
      height: 6.4vh;
      font-size: 1.3vw;
      line-height: 1.2;
      color: #e9e9e9;
      margin-top: 5px;
    }
    .hidden-item {
      opacity: 0;
      filter: Alpha(opacity=0);
      z-index: -1;
    }
  }
}
</style>
